<template>
    <div>
        <template v-if="loaded">
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        label="Data da requisição"
                        disabled
                        v-model="form.dataRequisicao"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Número"
                        disabled
                        v-model="form.numero"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-area title="Dados do requisitante">
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input
                            label="Unidade"
                            disabled
                            v-model="form.requisitante.unidadeNomeFantasia"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-input
                            label="Local de atendimento"
                            disabled
                            v-model="form.requisitante.infraestruturaNome"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input
                            label="Setor"
                            disabled
                            v-model="form.requisitante.setorNome"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-input
                            label="Usuário"
                            disabled
                            v-model="form.requisitante.usuarioNome"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-form ref="Form">
                <rkm-area title="Materiais">
                    <rkm-table
                        :fields="fields"
                        :items="itensOrdenados"
                        class="table-materiais"
                        hide-filters
                        hide-pagination
                        @sort-changed="handleSortChange"
                    >
                        <template v-slot:cell(material.descricaoCompleta)="{ item }">
                            {{ item.material.descricaoCompleta }}
                            <span
                                @click="$refs.ModalHistorico.open(item, id)"
                                class="cursor-pointer"
                                title="Visualizar histórico de saídas"
                                v-rkm-tooltip.hover
                            >
                                <rkm-icon icon="history" />
                            </span>
                        </template>

                        <template v-slot:cell(estoqueDisponivel)="{ item }">
                            {{ item.estoqueDisponivel }}
                            <span
                                v-if="item.reservas.length > 0"
                                @click="$refs.ModalReserva.open(item)"
                                class="cursor-pointer"
                                title="Visualizar reservas"
                                v-rkm-tooltip.hover
                            >
                                <rkm-icon icon="layer-group" />
                            </span>
                        </template>

                        <template v-slot:cell(concedido)="{ item }">
                            <rkm-form-input
                                :disabled="item.estoqueDisponivel === 0"
                                :validations="getConcedidoValidations(item)"
                                @change="handleConcedidoChange(item)"
                                class="my-auto quantidade-concedida"
                                name="Conceder"
                                number
                                v-model="item.concedido"
                            >
                                <rkm-input-group-append
                                    v-if="item.possuiEntradaComLote"
                                    slot="append"
                                >

                                    <rkm-button
                                        :disabled="!isConcedidoValido(item)"
                                        @click.stop="$refs.ModalLote.open(
                                            item.entradaItens,
                                            (entradaItens) => onSaveLotes(item, entradaItens)
                                        )"
                                        title="Visualizar lotes"
                                        v-rkm-tooltip.hover
                                    >
                                        <rkm-icon icon="box-open" />
                                    </rkm-button>
                                </rkm-input-group-append>
                            </rkm-form-input>
                        </template>

                        <template v-slot:cell(motivo)="{ item }">
                            <rkm-form-select
                                :disabled="isNaN(parseInt(item.concedido))"
                                :options="getMotivos(item)"
                                :validations="getMotivoValidations(item)"
                                @change="handleMotivoChange($event, item)"
                                class="my-auto motivo"
                                name="Motivo"
                                show-default-option
                                text-field="nome"
                                v-model="item.motivoId"
                                value-field="id"
                            >
                                <rkm-input-group-append
                                    v-if="item.motivoId === enums.requisicaoRespostaItemMotivo.OUTRO"
                                    slot="append"
                                >
                                    <rkm-button
                                        @click="$refs.ModalMotivo.open(item, false)"
                                        title="Visualizar motivo"
                                        v-rkm-tooltip.hover
                                    >
                                        <rkm-icon icon="clipboard" />
                                    </rkm-button>
                                </rkm-input-group-append>
                            </rkm-form-select>
                        </template>
                    </rkm-table>
                </rkm-area>

                <rkm-row class="mt-2">
                    <rkm-col>
                        <rkm-form-textarea
                            :maxlength="validations.observacoes.max"
                            :validations="validations.observacoes"
                            label="Observações"
                            v-model="model.observacoes"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <rkm-area
                v-if="form.envios.length > 0"
                title="Envios anteriores"
            >
                <rkm-list
                    :items="form.envios"
                    hide-filters
                >
                    <template v-slot="{ item }">
                        <strong>{{ item.numeroEnvio }}ª envio ({{ item.dataHora }}<span v-if="item.usuario"> - {{ item.usuario }}</span>)</strong>
                    </template>

                    <template v-slot:collapse="{ item }">
                        <div class="p-2">
                            <rkm-row>
                                <rkm-col>
                                    <rkm-table
                                        :fields="getEnvioFields(item.numeroEnvio === 1)"
                                        :items="item.itens"
                                        hide-filters
                                        hide-pagination
                                        class="table-materiais"
                                    >
                                        <template v-slot:cell(concedido)="{ item }">
                                            <template v-if="item.possuiEntradaComLote">
                                                <template v-if="item.entradaItens.length > 0">
                                                    <div
                                                        v-for="(lote, i) in item.entradaItens"
                                                        :key="`${i}${lote.lote}`"
                                                    >
                                                        {{ lote.concedido }}
                                                    </div>
                                                </template>

                                                <template v-else>
                                                    0
                                                </template>
                                            </template>

                                            <template v-else>
                                                {{ item.concedido }}
                                            </template>
                                        </template>

                                        <template v-slot:cell(lote)="{ item }">
                                            <template v-if="item.possuiEntradaComLote">
                                                <template v-if="item.entradaItens.length > 0">
                                                    <div
                                                        v-for="(lote, i) in item.entradaItens"
                                                        :key="`${i}${lote.lote}`"
                                                    >
                                                        {{ lote.lote || '-' }}
                                                    </div>
                                                </template>

                                                <template v-else>
                                                    -
                                                </template>
                                            </template>

                                            <template v-else>
                                                -
                                            </template>
                                        </template>

                                        <template v-slot:cell(validadeLote)="{ item }">
                                            <template v-if="item.possuiEntradaComLote">
                                                <template v-if="item.entradaItens.length > 0">
                                                    <div
                                                        v-for="(lote, i) in item.entradaItens"
                                                        :key="`${i}${lote.lote}`"
                                                    >
                                                        {{ lote.validadeLote || '-' }}
                                                    </div>
                                                </template>

                                                <template v-else>
                                                    -
                                                </template>
                                            </template>

                                            <template v-else>
                                                -
                                            </template>
                                        </template>

                                        <template v-slot:cell(motivo)="{ item }">
                                            {{ item.motivoNome || '-' }}

                                            <template v-if="item.motivoOutro">
                                                <span
                                                    @click="$refs.ModalMotivo.open(item, true)"
                                                    class="cursor-pointer"
                                                    title="Visualizar motivo"
                                                    v-rkm-tooltip.hover
                                                >
                                                    <rkm-icon icon="clipboard" />
                                                </span>
                                            </template>
                                        </template>
                                    </rkm-table>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row
                                v-if="item.observacoes"
                                class="mt-2"
                            >
                                <rkm-col>
                                    <span>
                                        <strong>Observações</strong>
                                    </span>

                                    <p class="m-0">{{ item.observacoes }}</p>
                                </rkm-col>
                            </rkm-row>
                        </div>
                    </template>
                </rkm-list>
            </rkm-area>
        </template>

        <ModalLote ref="ModalLote" />
        <ModalHistorico ref="ModalHistorico" />
        <ModalReserva ref="ModalReserva" />
        <ModalMotivo ref="ModalMotivo" />
    </div>
</template>

<script>
// Components.
import ModalLote from '@/components/almoxarifado/components/lote/Modal'
import ModalHistorico from './components/historico/Modal'
import ModalReserva from './components/reserva/Modal'
import ModalMotivo from './components/motivo/Modal'

// Others.
import { repository, error, object, stringCase } from '@/mixins'
import { mapActions } from 'vuex'
import requisicaoRespostaItemMotivo from '@/enums/almoxarifado/requisicaoRespostaItemMotivo'

export default {
    components: { ModalLote, ModalHistorico, ModalReserva, ModalMotivo },
    computed: {
        fields() {

            const fields = this.getFields(false)

            if (this.hasEnviosAnteriores) {

                return [
                    fields.material,
                    fields.entregue,
                    fields.restanteRequisitado,
                    fields.estoqueDisponivel,
                    fields.estoqueRequisitante,
                    fields.concedido,
                    fields.motivo,
                ]
            }

            return [
                fields.material,
                fields.requisitado,
                fields.estoqueDisponivel,
                fields.estoqueRequisitante,
                fields.concedido,
                fields.motivo,
            ]
        },
        hasEnviosAnteriores() {

            return this.form.envios.length > 0
        },
        validations() {

            return {
                observacoes: {
                    max: 1000
                }
            }
        },
        itensOrdenados() {
            return [...this.model.itens].sort((a, b) => {
                const nomeA = a.material.descricaoCompleta?.toLowerCase() || ''
                const nomeB = b.material.descricaoCompleta?.toLowerCase() || ''
                return nomeA.localeCompare(nomeB)
            })
        }
    },
    created() {

        this.repositories = {
            requisicao: this.getConectaSusRepository('almoxarifado.requisicaoPendentePermissao'),
            impressao: this.getConectaSusRepository('impressao.almoxarifado'),
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        form: null,
        model: null,
        modelLote: {},
        sortDirection: 'asc',
        enums: { requisicaoRespostaItemMotivo }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        getFields(isRespostaAnterior) {

            return {
                material: {
                    key: 'material.descricaoCompleta',
                    label: 'Material',
                    sortable: true,
                },
                requisitado: {
                    key: 'requisitado',
                    label: 'Requisitado',
                    class: 'col-min text-center'
                },
                entregue: {
                    key: 'entregue',
                    label: 'Entregue',
                    class: 'col-min text-center'
                },
                restanteRequisitado: {
                    key: 'restanteRequisitado',
                    label: 'Restante requisitado',
                    class: 'col-min text-center'
                },
                estoqueDisponivel: {
                    key: 'estoqueDisponivel',
                    label: 'Estoque disponível',
                    class: 'col-min text-center'
                },
                estoqueRequisitante: {
                    key: 'estoqueRequisitante',
                    label: 'Estoque do requisitante',
                    class: 'col-min text-center'
                },
                concedido: {
                    key: 'concedido',
                    label: isRespostaAnterior ? 'Concedido' : 'Conceder',
                    class: 'col-min text-center'
                },
                lote: {
                    key: 'lote',
                    label: 'Lote',
                    class: 'col-min text-center'
                },
                validadeLote: {
                    key: 'validadeLote',
                    label: 'Validade',
                    class: 'col-min text-center'
                },
                motivo: {
                    key: 'motivo',
                    label: 'Motivo',
                    class: 'col-min' + (isRespostaAnterior ? '' : ' text-center')
                },
            }
        },
        getEnvioFields(isPrimeiroEnvio) {

            const fields = this.getFields(true)

            return isPrimeiroEnvio ? [
                fields.material,
                fields.requisitado,
                fields.concedido,
                fields.lote,
                fields.validadeLote,
                fields.motivo,
            ] : [
                fields.material,
                fields.entregue,
                fields.restanteRequisitado,
                fields.concedido,
                fields.lote,
                fields.validadeLote,
                fields.motivo,
            ]
        },
        getConcedidoValidations(item) {

            return {
                required: true,
                max_value: item.estoqueDisponivel,
            }
        },
        isConcedidoValido(item) {

            if (!item.concedido) {

                return false
            }

            const concedido = parseInt(item.concedido)

            return concedido > 0 && concedido <= item.estoqueDisponivel
        },
        handleConcedidoChange(item) {

            const concedido = parseInt(item.concedido)

            if (isNaN(concedido)
                ||(this.hasEnviosAnteriores && concedido == item.restanteRequisitado)
                || (!this.hasEnviosAnteriores && concedido == item.requisitado)
            ) {

                item.motivoId = null
                item.motivoOutro = null
            }

            if (item.possuiEntradaComLote && this.isConcedidoValido(item)) {

                this.selectEntradaItens(item)
            }
        },
        selectEntradaItens(item) {

            item.escolheuEntradaItemManualmente = false

            item.entradaItens.map(e => e.quantidadeSaida = 0)

            let concedido = parseInt(item.concedido)
            let i = 0

            while (concedido > 0) {

                const entradaItem = item.entradaItens[i]
                const estoque = parseInt(entradaItem.estoque)

                if (concedido > estoque) {

                    entradaItem.quantidadeSaida = estoque
                    concedido -= estoque
                }
                else {

                    entradaItem.quantidadeSaida = concedido
                    concedido = 0
                }

                i++
            }
        },
        onSaveLotes(item, entradaItens) {

            let concedido = 0

            entradaItens
                .filter(ei => !isNaN(parseInt(ei.quantidadeSaida)))
                .forEach(ei => concedido += parseInt(ei.quantidadeSaida))

            item.escolheuEntradaItemManualmente = concedido > 0
            item.concedido = concedido
            item.entradaItens = this.clone(entradaItens)
        },
        getMotivos(item) {

            const concedido = parseInt(item.concedido)
            const motivosParaRemover = []

            if ((this.hasEnviosAnteriores && item.estoqueDisponivel >= item.restanteRequisitado)
                || (!this.hasEnviosAnteriores && item.estoqueDisponivel >= item.requisitado)
            ) {

                motivosParaRemover.push(this.enums.requisicaoRespostaItemMotivo.SEM_ESTOQUE)
            }

            if (concedido == 0
                || (this.hasEnviosAnteriores && concedido >= item.restanteRequisitado)
                || (!this.hasEnviosAnteriores && concedido >= item.requisitado)
            ) {

                motivosParaRemover.push(this.enums.requisicaoRespostaItemMotivo.PEDIDO_EM_EXCESSO)
                motivosParaRemover.push(this.enums.requisicaoRespostaItemMotivo.ENTREGA_PARCIAL)
            }

            if (concedido == 0
                || (this.hasEnviosAnteriores && concedido == item.restanteRequisitado)
                || (!this.hasEnviosAnteriores && concedido == item.requisitado)
            ) {

                motivosParaRemover.push(this.enums.requisicaoRespostaItemMotivo.ADEQUACAO_DE_CAIXA)
            }

            if (concedido > 0) {

                motivosParaRemover.push(this.enums.requisicaoRespostaItemMotivo.PENDENTE_DE_ENTREGA)
                motivosParaRemover.push(this.enums.requisicaoRespostaItemMotivo.RECUSADO)
            }

            const motivos = this.form.motivos.filter(m => !motivosParaRemover.includes(m.id))

            if (!motivos.find(m => m.id === item.motivoId)) {

                item.motivoId = null
                item.motivoOutro = null
            }

            return motivos
        },
        getMotivoValidations(item) {

            const concedido = parseInt(item.concedido)

            if((this.hasEnviosAnteriores && (concedido == item.restanteRequisitado)) || (!this.hasEnviosAnteriores && (concedido == item.requisitado))) {
                return { required: false }
            } else {
                return { required: this.form.motivoObrigatorio }
            }
        },
        load() {

            this.setLoading()

            this.repositories.requisicao.edit(this.id)
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.model.itens.map(item => {

                        if (!this.getMotivos(item).find(m => m.id === item.motivoId)) {

                            item.motivoId = null
                        }
                    })

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleMotivoChange(motivoId, item) {

            if (motivoId === this.enums.requisicaoRespostaItemMotivo.OUTRO) {

                this.$refs.ModalMotivo.open(item, false)
            }
            else {

                item.motivoOutro = null
            }
        },
        save(print = false) {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.showConfirmation(
                        `Ao salvar, a resposta da requisição não será enviada, apenas serão
                        reservadas as quantidades concedidas. Deseja continuar?`,
                        async () => this.handleSave(false, print)
                    )
                })
        },
        sendAnswer() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.showConfirmation(
                        'Ao enviar a resposta, as quantidades concedidas serão baixadas do estoque. Deseja continuar?',
                        async () => this.handleSave(true)
                    )
                })
        },
        handleSave(enviarResposta, print = false) {

            this.setLoading()

            this.repositories.requisicao.update(this.id, this.prepareData(enviarResposta))
                .then(() => {

                    this.showSaveNotification()

                    if (print) {

                        this.print()
                    }

                    if (enviarResposta) {

                        this.$emit('save')
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData(enviarResposta) {

            const itens = this.clone(this.model.itens).map(item => ({
                requisicaoItemId: item.requisicaoItemId,
                concedido: parseInt(item.concedido),
                escolheuEntradaItemManualmente: item.escolheuEntradaItemManualmente,
                entradaItens: item.entradaItens.filter(i => i.quantidadeSaida > 0),
                motivoId: item.motivoId,
                motivoOutro: item.motivoOutro,
            }))

            return this.camelObjectKeysToSnakeRecursive({
                enviarResposta,
                itens,
                observacoes: this.model.observacoes,
            })
        },
        handleSortChange(ctx) {
            ctx.sortDesc ? this.sortDirection = 'desc' : this.sortDirection = 'asc'
        },
        print() {

            this.setLoading()

            this.repositories.impressao.requisicao(this.id, this.sortDirection)
                .then(response => {
                    const content = new Blob([response.data], { type: response.headers['content-type'] })
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        printSeparacaoMaterial() {

            this.setLoading()

            this.repositories.impressao.requisicaoSeparacaoMaterial(this.id, this.sortDirection)
                .then(response => {

                    const content = new Blob([response.data], { type: response.headers['content-type'] })
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [repository, error, object, stringCase],
    props: {
        id: { type: Number },
    },
}
</script>

<style scoped>
.table-materiais >>> .quantidade-concedida {
    min-width: 150px;
}
.table-materiais >>> .motivo {
    min-width: 220px;
}
.table-materiais >>> .cursor-pointer {
    cursor: pointer;
}
</style>